import { BlogCardsGrid } from '../../../js/src/__utils/sliders';

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		BlogCardsGrid.init();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
